import React from 'react';
import { KiteMeter, KiteTabs, KiteTab } from '@kite/react-kite';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { AccentedText } from '../AccentedText/AccentedText';
import './Infographic.scss';

export interface InfographicProps {
    tabs: InfographicTabProps[];
    percent: number;
    infographicText: string;
}

export interface InfographicTabProps {
    text?: string;
    heading: string;
    tabTitle: string;
    image?: IGatsbyImageData;
    imageAlt?: string;
}

export const Infographic = (props: InfographicProps) => {
    const [currentTab, setCurrentTab] = React.useState(0);
    const percent = props.percent;

    if (
        !props.tabs ||
        props.tabs.length < 1 ||
        props.tabs.some((tab) => !tab.heading)
    ) {
        return (
            <p className="kite-container component-error">
                ERROR: Infographic tab - All infographic tabs must be populated
            </p>
        );
    }

    return (
        <div className="infographic">
            <KiteMeter
                type="circular"
                value={percent / 100}
                label="Total Potential Reach"
                size="large"
                valueLabel={`${percent}%`}
                className="typestack-title-3"
            />
            {props.tabs && (
                <div className="kite-container">
                    <KiteTabs
                        selectedIndex={currentTab}
                        focusChange={setCurrentTab}
                    >
                        {props.tabs.map((tab, idx) => (
                            <KiteTab
                                label={
                                    <AccentedText>{tab.heading}</AccentedText>
                                }
                                key={idx}
                            >
                                <div className="text-container">
                                    <h3 className="typestack-title-4">
                                        {tab.tabTitle}
                                    </h3>
                                    <div
                                        className="text"
                                        dangerouslySetInnerHTML={{
                                            __html: tab.text,
                                        }}
                                    ></div>
                                </div>
                                {tab.image && (
                                    <div>
                                        <GatsbyImage
                                            image={tab.image}
                                            alt={tab.imageAlt ?? ``}
                                        />
                                    </div>
                                )}
                            </KiteTab>
                        ))}
                    </KiteTabs>
                </div>
            )}
        </div>
    );
};
